import React, { ReactElement } from 'react';
import { AutocompleteSource } from '../inputs/autocompleteInput/AutocompleteSource';
import Chip from './Chip';

type Props = {
  removeChip: (label: string) => void,
  elements: AutocompleteSource[],
  className?: string,
};

type State = {
  overflowingChips: number
};

class ChipsList extends React.Component<Props, State> {
  state: State = {
    overflowingChips: 0,
  };

  listRef = React.createRef<HTMLDivElement>();

  expandList = (): void => {
    if (this.listRef.current) {
      this.listRef.current.classList.add('expanded');
    }
  };

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>): void {
    let overflowingChips = 0;
    if (this.listRef.current && !this.listRef.current.classList.contains('expanded')) {
      const elementsArray = Array.from(this.listRef.current?.children);
      const min = elementsArray.reduce((acc, val: HTMLElement) =>
        Math.min(acc, val.offsetTop), 2000);
      elementsArray.forEach((element: HTMLElement) => {
        if (element.offsetTop > min) overflowingChips += 1;
      });
      if (this.state.overflowingChips !== overflowingChips) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ overflowingChips });
      }
    }
  }

  static defaultProps: { className: string };

  render(): ReactElement {
    return (
      <>
        <div ref={this.listRef} className={`chips-list ${this.props.className}`}>
          {this.props.elements.filter((entry) => entry).map((entry) => (
            <Chip
              key={entry.id}
              removeChip={() => this.props.removeChip(entry.label)}
              name={entry.label}
            />
          ))}
        </div>
        {!!this.state.overflowingChips && <Chip removeChip={this.expandList} name={`+ ${this.state.overflowingChips} autre${this.state.overflowingChips === 1 ? '' : 's '}`} /> }
      </>
    );
  }
}
ChipsList.defaultProps = {
  className: '',
};

export default ChipsList;
